import { useState } from 'react'

import { Modal } from 'almanac-ui/Modal'
import { Button } from 'components/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { ReactComponent as CloseArrow } from 'assets/icons/arrowLeft16.svg'
import Avatar from 'common/Avatar/Avatar'
import useShareSheetV2 from 'hooks/useShareSheetV2'
import { getInitials } from 'utils'
import { TransferOwnershipConfirmationProps } from './Types'
import Styles from './ShareSheet.module.scss'

export const TransferOwnershipConfirmation = ({ newOwner, file }: TransferOwnershipConfirmationProps) => {
  const { isMobile } = useResponsiveDesign()
  const fileType = file.type === 'article' ? 'document' : file.type
  const { transferOwnership, setShareSheet } = useShareSheetV2(file)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { avatar_url, name, id } = newOwner
  const goBack = () => {
    setShareSheet({ transferOwnershipUser: null })
    setIsSubmitting(false)
  }

  const handleTransfer = () => {
    setIsSubmitting(true)
    transferOwnership({ goBack, id })
  }

  return (
    <Modal.Root size={isMobile ? 'xs' : 'sm'}>
      <Modal.Top>
        <Button size="md" onPress={goBack} variant="tertiary" className={Styles.backButton}>
          <CloseArrow />
        </Button>
      </Modal.Top>
      <Modal.Header title={<div className={Styles.title}>Make this person the owner?</div>} />
      <Modal.Content>
        <div className={Styles.userTab}>
          <Avatar url={avatar_url} label={getInitials(name)} size={20} staticColor />
          {name}
        </div>

        <div className={Styles.transferText}>
          This person will be notified and could remove your access to this {fileType}. You also might lose the ability
          to change this {fileType}’s share settings.
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={goBack}>
            Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button size="lg" onPress={handleTransfer} isDisabled={isSubmitting}>
            Transfer Ownership
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
